import { ALERT_EXCLUSION_URIS } from 'constant/alert';
import { isBrowser } from 'lib/browser';
export const isAlertExclusionPage = () =>
  isBrowser &&
  (ALERT_EXCLUSION_URIS.includes(window?.location?.pathname) ||
    ALERT_EXCLUSION_URIS.some((uri: string) => window?.location?.pathname?.includes(uri)));
